<div style="display: block">
    <canvas mdbChart
        [chartType]="chartType"
        [data]="chartData"
        [labels]="chartLabels"
        [colors]="chartColors"
        [options]="chartOptions"
        [legend]="true"
        (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)">
    </canvas>
</div>
